import script from "./FlashMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./FlashMessages.vue?vue&type=script&setup=true&lang=js"

import "./FlashMessages.vue?vue&type=style&index=0&id=7cbabd66&lang=scss"

const __exports__ = script;

export default __exports__